<svelte:head>
	<link rel="preconnect" href="https://fonts.googleapis.com">
	<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
	<link href="https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap" rel="stylesheet">
	<link href="https://fonts.googleapis.com/css2?family=Spartan:wght@300;400;500;600;700;800;900&display=swap" rel="stylesheet">
</svelte:head>

<script>
	import dayjs from 'dayjs';
	import advancedFormat from 'dayjs/plugin/advancedFormat';
	import { PhoneNumberUtil } from 'google-libphonenumber';
	import _ from 'lodash';
	import { onMount, tick } from 'svelte';
	import { Circle as LoadingCircle } from 'svelte-loading-spinners';
	import { fade, fly } from 'svelte/transition';
	import Swipe from 'swipejs';
	import firstBy from 'thenby';
	import AddressInput from './AddressInput.svelte';
	import TextInput from './TextInput.svelte';
	import { api } from './api.js';
	import { errors } from './errors.js';
	dayjs.extend(advancedFormat);
	const phoneUtil = PhoneNumberUtil.getInstance();

	const config = {
		omiseSettings: {
			publicKey: {
				live: 'pkey_5qu3oo8b3nr499mqx3c',
				test: 'pkey_test_5oooft3ythrrdah8ysk'
			},
		},
		googleMapsClientKey: 'AIzaSyB8qM2-_csV7jQZ4PGac1Uhj8yRNAClB_Q',
		kitchenAddress: {lat: 3.118052326332586, lng: 101.63741396011723}, //The Gasket Alley
		logInteractions: false,
		maximumBoxesPerOrder: 4,
		minimumChargeableOrder: 1, //MYR
		openingHour: 11, //11am //TODO TBI make this editable from store-tool
		openingTimeGracePeriod: 5*60*1000, //5mins
		paymentGracePeriod:	5, //mins
		personalizedMessageLimits: {
			maxLines: 4,
			maxChars: 150,
		},
		slides: {
			WELCOME: 0,
			DATES: 1,
			MENU: 2,
			RECIPIENT: 3,
			REVIEW: 4,
		},
		stapleFlavors: [
			"Baby Cinnamon Affairs",
			"Brown Baby",
			"Burnt & Salty",
			"Crème Brûlée",
			"Lemon Pop",
			"Maple Bacon",
		],
		usePhotoMenu: true,
	};

	const today = dayjs().format('YYYY/MM/DD');

	let boxes = { num:1, curr:0 };
	let error;
	let missingMenuItemImageCount = 0;
	let loading = true;
	let loadingGoogleMaps = true;
	let menu = {
		daySettings: {},
		timeSettings: {
			pickupWindow:   '1.30pm - 4.30pm',
			deliveryWindow: '1.30pm - 3.00pm',
		},
	};
	let order = { slot:      dayjs().add(1,'days').format('YYYY/MM/DD'),
	              items:     {},
	              subtotals: [],
	              total:     0,
	              shipping:  0,
	              recipient: { fromHandle:	'',
	                           fromName:	'',
	                           fromTel:		'',
	                           pickup:		false,
	                           toSelf:		true,
	                           toName:		'',
	                           toTel:		'',
	                           toAddr:		'',
	                           remarks:		'' },
	              notes:     '',
	              status:    'DRAFT',
	              promoId:   null,
  	              numPreOrderItems: 0 };
	let promos = [];
	let showExpandedItem = {
		mi: null,
		showDetails: false, // used to separate the bg fade and drawer fly animations
	};
	let showTnCs;
	let user = { fromHandle: window.localStorage.getItem('fromHandle') || '',
	             authToken:  window.localStorage.getItem('authToken') || '' };
	let userStatus = (!user.fromHandle || !user.authToken) ? 'NEW' : 'OK';

	let inputValidatorFns = {
		fromHandle:	v => /^@{0,1}[a-z0-9\._]{1,30}$/i.test(v),
		OTP:		v => /^[0-9]{6}$/.test(v),
		fromName:	v => v.trim() && v.length < 100,
		toName:		v => v.trim() && v.length < 100,
		fromTel:	isValidMalaysianPhoneNumber,
		toTel:		isValidMalaysianPhoneNumber,
		toAddr:		v => v.trim(),
		remarks:	v => v.length < 100,
		notes:		v => (v.match(/\n/g) || []).length <= config.personalizedMessageLimits.maxLines-1 &&
		                 v.length < config.personalizedMessageLimits.maxChars,
	};

	function areAllSlotsClosed() {
		return !Object.keys(menu.daySettings).some(hasOrderableItems);
	}

	function clearError() {
		if( error && error.clear == 'onBlur' )
			error = undefined;
	}

	function clearPrePaymentState() {
		window.localStorage.removeItem('prePaymentState');
	}

	function fetchAndSetDeliveryCharge() {
		api.getDeliveryCharge(order.slot, order.recipient.toAddr)
		.then( amount => {
			logInteraction('received-shipping-quote', {amount});
			order.shipping = amount;
		 })
		.catch( err => {
			logInteraction('received-shipping-quote', {err});
			if( err == 423 )      showError(errors.too_far);
			else if( err == 503 ) showError(errors.no_lalamove);
			else                  showError(errors.no_network);
		});
	}

	/* return number of given item in current box */
	function getItemQty(mi) {
		return Array.isArray(order.items[mi.name]) && order.items[mi.name][boxes.curr] || 0;
	}

	/* return number of given item over all boxes */
	function getItemQtyAllBoxes(mi) {
		return Array.isArray(order.items[mi.name]) && order.items[mi.name].map( n => n || 0 ).reduce( (a,b) => a+b, 0);
	}

	function hasOrderableItems(day) {
		return  (menu.daySettings[day] &&
				 menu.daySettings[day].menu &&
				 menu.daySettings[day].menu.some( mi => !mi.soldout )) ||
				(menu.daySettings[day] &&
				 menu.daySettings[day].dailys &&
				 menu.daySettings[day].dailys.some( mi => !mi.soldout ));
	}

	/* add/remove items from current box */
	function incrementItemQty(mi,inc) {
		logInteraction('changed-order', {
			change: `${inc > 0 ? '+' : ''}${inc} ${mi.name}`,
			total: order.total + inc*mi.price,
		});
		order.items[mi.name] = order.items[mi.name] || [];
		order.items[mi.name][boxes.curr] = order.items[mi.name][boxes.curr] || 0;
		order.items[mi.name][boxes.curr] += inc;
		order.subtotals[boxes.curr] = order.subtotals[boxes.curr] || 0;
		order.subtotals[boxes.curr] += inc*mi.price;
		order.total += inc*mi.price;

		if( !isDailyItem(mi.name) )
			order.numPreOrderItems += inc;
	}

	function initOmise() {
		function pay(payOrderArgs) {
			logInteraction('sent-payment');
			clearError();
			api.payOrder(payOrderArgs)
			.then(result => {
				if( result.authorize_uri ) {
					logInteraction('received-payment-challenge');
					storePrePaymentState();
					window.location = result.authorize_uri;
				} else {
					logInteraction('received-payment-complete');
					order.status = 'CONFIRMED';
				}
			})
			.catch(err => {
				logInteraction('received-payment-failed', {err});
				if( err == 403 ) {
					showError(errors.payment_failed);
					openOmisePaymentForm();
				}
				else if( err == 404 ||
				         err == 409 )	showError(errors.booking_expired);
				else if( err == 500 )	showError(errors.internal_error);
				else if( err == 507 )	showError(errors.no_omise_internal);
				else /* err == 503 */	showError(errors.no_omise);
			});
		}

		OmiseCard.configure({
			publicKey: config.omiseSettings.publicKey.live,
			currency: 'MYR',
			frameLabel: 'Good Dough Sdn Bhd',
			defaultPaymentMethod: 'credit_card',
			onCreateTokenSuccess: nonce => {
				pay({orderId:order.id, omiseToken:nonce});
			},
			onFormClosed: () => {
				openOmisePaymentForm();
			}
		});

		/* the default DOM positioning of the omise payment iframe is so so: it
		   gets added to the end of the body, which bypasses the scrolling
		   behavior on our swiper slides, which causes problems on smaller
		   screens (like mine). here i move it within the appropriate slide. */
		let omiseLoadingDiv = document.getElementById('omiseLoading');
		let omiseIframe = document.getElementById('omise-checkout-iframe-app');
		if( omiseIframe )
			omiseLoadingDiv.parentNode.appendChild(omiseIframe);

		return {pay};
	}

	function initSwiper(startSlide) {
		let slider = document.getElementById('slider');
		slider.style.display = 'block';
		window.mySwipe = new Swipe(slider, {
			startSlide: startSlide || config.slides.WELCOME,
			draggable: true,
			continuous: false,
			callback: (index,elem,dir) => {
				logInteraction('navigated', {
					from: Object.entries(config.slides).find( ([name,i]) => i == index+dir )[0],
					to: Object.entries(config.slides).find( ([name,i]) => i == index )[0],
				});
			}
		});
	}

	/* return true if the given item is a daily item or a sameday weekly (as
	   opposed to a preorder weekly item) */
	function isDailyItem(name) {
		let daySettings = menu.daySettings[order.slot];
		if( daySettings ) {
			let dailyMenu = daySettings.dailys || [];
			let samedayWeeklyMenu = (daySettings.menu || []).filter( mi => 'stock' in mi );
			return dailyMenu.find( mi => mi.name == name ) ||
					samedayWeeklyMenu.find( mi => mi.name == name );
		}
		return false;
	}

	/* returns true if the delivery has been disabled for the given slot */
	function isDeliveryUnavailable() {
		return menu.daySettings[order.slot] &&
				menu.daySettings[order.slot].deliveryUnavailable;
	}

	/* return true if the given item is still in stock (for dailys), or within
	   our remaining capacity (for weeklys) */
	function isItemAddableToOrder(mi) {
		if( mi.soldout )
			return false;
		else if( isDailyItem(mi.name) )
			return getItemQtyAllBoxes(mi) < mi.stock;
		else
			return order.numPreOrderItems < (menu.daySettings[order.slot] ? menu.daySettings[order.slot].preOrderCapacity : -Infinity);
	}

	/* returns true if the given day is today and we haven't opened dailys yet
	   and we're within [midnight, openingTime+openingTimeGracePeriod[ */
	function isOpeningSoon(day) {
		const now = dayjs();
		const today = now.format('YYYY/MM/DD');
		const openingTime = dayjs(`${today} ${config.openingHour}:00 AM`);

		return day == today &&
				menu.daySettings[today] &&
				!menu.daySettings[today].dailys &&
				openingTime.diff(now) + config.openingTimeGracePeriod > 0;
	}

	/* returns true if the minimum order (at least 1 item) is met */
	function isOrderQtySufficient() {
		return Object.values(order.items).flat().some( qty => qty > 0 );
	}

	/// COPIED FROM backend/utils.js
	function isValidMalaysianPhoneNumber(num) {
		try {
			return phoneUtil.isValidNumberForRegion( phoneUtil.parse(num,'MY'), 'MY');
		} catch(err) {
			return false;
		}
	}

	/* returns true if all the mandatory recipient fields have values */
	function isRecipientValid() {
		let r = order.recipient;

		return inputValidatorFns.fromName(r.fromName) 				&&
				inputValidatorFns.fromTel(r.fromTel) 				&&
				(r.pickup || inputValidatorFns.toAddr(r.toAddr)) 	&&
				(r.toSelf ||
					(inputValidatorFns.toName(r.toName) &&
					 inputValidatorFns.toTel(r.toTel)) );
	}

	function loadGoogleMapsLibrary() {
		return new Promise((resolve,reject) => {
			let script = document.createElement('script');
			script.src = `https://maps.googleapis.com/maps/api/js?key=${config.googleMapsClientKey}&libraries=places`;
			script.onload = resolve;
			script.onerror = reject;
			document.head.append(script);
		});
	}

	function loadOmiseLibrary() {
		return new Promise((resolve,reject) => {
			let script = document.createElement('script');
			script.src = `https://cdn.omise.co/omise.js`;
			script.onload = resolve;
			script.onerror = reject;
			document.head.append(script);
		});
	}

	function login(fromHandle,authToken) {
		window.localStorage.setItem('fromHandle',fromHandle);
		window.localStorage.setItem('authToken',authToken);
		reloadPage();
	}

	function logInteraction(tag,args) {
		if( config.logInteractions ) {
			console.log(tag,args);
			api.logInteraction(tag,args);
		}
	}

	function measureTextWidth(text) {
		let canvas = document.createElement("canvas");
		let width = canvas.getContext('2d').measureText(text).width;
		canvas.remove();
		return width;
	}

	function onAddressChange(newAddr) {
		logInteraction('changed-address', {newAddr});
		order.recipient.toAddr = newAddr;
		if( order.recipient.toAddr )
			fetchAndSetDeliveryCharge();
		else
			order.shipping = 0;
	}

	/* called whenever the user clicks/taps/swipes away from whatever is
	   focused. this triggers hiding of hide-on-blur errors and blurring of
	   focused elements (which, among other things, closes the keyboard on
	   mobile). */
	function onBlur(ev) {
		clearError();
		document.activeElement.blur();
	}

	/* display a configured and stylized omise payment form

	   NOTE: the default styling of the omise payment form is so-so: on mobile,
	   it takes up the whole screen and feels almost like a redirect. so i
	   emulated the adyen dropin styling, which feels much more integrated into
	   the host site.

	   NOTE: left and top are treated differently because we want their
	   "declared" value, not their computed value, but declared values are not
	   accessible programmatically */
	function openOmisePaymentForm() {
		OmiseCard.open({
			amount: Math.round(orderAmount()*100),
			frameDescription: `Order #${order.id}`,
		});

		let omiseLoadingDiv = document.getElementById('omiseLoading');
		let omiseStyle = window.getComputedStyle(omiseLoadingDiv);
		let omiseIframe = document.getElementById('omise-checkout-iframe-app');
		if( omiseIframe ) {
			['backgroundColor','borderColor','borderRadius','borderStyle',
			 'borderWidth','boxShadow','height','width']
			 .forEach( attr => omiseIframe.style[attr] = omiseStyle[attr] );
			 omiseIframe.style.left = 'calc(50% - 320px/2)';
			 omiseIframe.style.top = 'min(18%, 150px)';
		 }
	}

	function orderAmount() {
		return order.promoId ?
				order.total + (order.recipient.pickup ? 0 : order.shipping) - promoAmount(order.promoId) :
				order.total + (order.recipient.pickup ? 0 : order.shipping);
	}

	// process and augment menu retrieved from backend for ease of use
	function prepareMenu() {
		// augment weekly items on today's menu with their stock count and
		// soldout status, taken from their dailys counterpart
		if( menu.daySettings[today] &&
			menu.daySettings[today].dailys ) {
			menu.daySettings[today].dailys
			.filter( mi => !mi.items )
			.forEach( mi => {
				let _mi = menu.daySettings[today].menu ?
							menu.daySettings[today].menu.find( ({name}) => mi.name == name ) :
							null;
				if( _mi ) {
					_mi.stock = mi.stock;
					_mi.soldout = mi.soldout;
				} else {
					/* ignore weekly items that are on the daily menu (i.e., as
					   sameday order items) but no longer on the weekly menu */
				}
			});
		}

		// leave only non-weekly items in dailys
		for( const [day,settings] of Object.entries(menu.daySettings) )
			if( menu.daySettings[day] &&
				menu.daySettings[day].dailys)
				menu.daySettings[day].dailys = menu.daySettings[day].dailys.filter( mi => mi.items );

		// create custom sorting of dailys + weeklys
		// - list multi-item dailys first,
		// - then dailys and non-staple monthlys, sorted by name,
		// - then staples, sorted by name
		for( const [day,settings] of Object.entries(menu.daySettings) ) {
			menu.daySettings[day].fullSortedMenu = [];
			menu.daySettings[day].fullSortedMenu = [
				menu.daySettings[day].dailys || [],
				(menu.daySettings[day].menu || []).filter( ({name}) => !config.stapleFlavors.includes(name) )
			].flat();
			menu.daySettings[day].fullSortedMenu.sort(
				firstBy( ({name, items}) =>
					(items && Object.values(items).map(({qty}) => qty).reduce((a,b)=>a+b, 0) > 1) || name.match(/ Stacks$/)
						? 1
						: 0, 'desc' )
				.thenBy( 'name' )
			);
			menu.daySettings[day].fullSortedMenu.push(
				...(menu.daySettings[day].menu || []).filter( ({name}) => config.stapleFlavors.includes(name) )
			);
		}

		// pre-compute useful/frequently used strings and variables
		for( const [day,settings] of Object.entries(menu.daySettings) )
			menu.daySettings[day].fullSortedMenu.forEach(mi => {
				mi.__normalizedName = mi.name.startsWith('V ') ? mi.name.substring(2) : mi.name;
				mi.__isMultiItem = (mi.items && Object.values(mi.items).map(({qty}) => qty).reduce((a,b)=>a+b, 0) > 1) || mi.name.match(/ Stacks$/);
				mi.__imageSrc = `menu-images/${mi.__normalizedName}.png`;
				mi.__placeholderImageSrc = mi.__isMultiItem ?
					i => 'menu-images/default-box.png' :
					i => `menu-images/default-one-0${(i % 6)+1}.png`;
			});

		// pre-compute useful date strings
		for( const [day,details] of Object.entries(menu.daySettings) ) {
			let d = dayjs(day);
			details.df = {
				YYYYMMDD: d.format('YYYY/MM/DD'),
				ddd:      d.format('ddd'),
				Do:       d.format('Do')
			};
		}
	}

	/// INSPIRED FROM frontend/src/utils.js
	/* return the actual discount that this promo will contribute given whether it
	   applies to delivery and/or items, and given that these may cost less than
	   the promo's cap */
	function promoAmount(promoId) {
		let itemsPrice = order.total;
		let shippingPrice = (order.recipient.pickup ? 0 : order.shipping);
		let p = promos.find( p => p.id == order.promoId );

		if( p.appliesTo == 'DELIV' )
			return Math.min(shippingPrice,p.maxAmount);
		else if( p.appliesTo == 'ITEMS' )
			return Math.min(itemsPrice,p.maxAmount);
		else /* p.appliesTo == 'ANY' */
			return Math.min(itemsPrice+shippingPrice,p.maxAmount);
	}

	function promoDescription(p) {
		if( p.appliesTo == 'ANY' )			return `Up to MYR ${p.maxAmount} off`;
		else if( p.appliesTo == 'ITEMS' )	return `Up to MYR ${p.maxAmount} off on your doughnuts`;
		else if( p.appliesTo == 'DELIV' )	return `Up to MYR ${p.maxAmount} off on your delivery charges`;
	}

	/* update order given quick order command */
	function quickOrder(shortcut) {
		switch(shortcut) {
			case 'add-box':
				let curr = boxes.curr;
				boxes.curr = boxes.num++;
				break;
		}
	}

	function registerWithoutOTP() {
		let input  = document.getElementById('fromHandle');
		let action = document.getElementById('requestOTP');
		input.blur();
		input.classList.add('disabled');
		action.classList.add('disabled');

		user.fromHandle = (user.fromHandle.startsWith('@') ? user.fromHandle : `@${user.fromHandle}`).toLowerCase();
		api.registerWithoutOTP(user.fromHandle)
		.then( authToken => login(user.fromHandle,authToken) )
		.catch( err => {
			showError(errors.internal_error_2);
			input.classList.remove('disabled');
			action.classList.remove('disabled');
		});
	}

	function reloadPage() {
		window.location = window.location.origin;
	}

	/* delete current box from order */
	function removeCurrentBox() {
		order.total -= (order.subtotals[boxes.curr] || 0);
		let numPreOrderItems = 0;
		for( let [name,_boxes] of Object.entries(order.items) ) {
			if( !isDailyItem(name) && _boxes[boxes.curr] > 0 )
				numPreOrderItems += _boxes[boxes.curr];
			_boxes.splice(boxes.curr,1);
		}
		order.subtotals.splice(boxes.curr,1);
		boxes.num--;
		boxes.curr = Math.min(boxes.curr, boxes.num-1);
		order.numPreOrderItems -= numPreOrderItems;
	}

	/* send an OTP to the given user's IG */
	function requestOTP() {
		let input  = document.getElementById('fromHandle');
		let action = document.getElementById('requestOTP');
		input.blur();
		input.classList.add('disabled');
		action.classList.add('disabled');

		user.fromHandle = (user.fromHandle.startsWith('@') ? user.fromHandle : `@${user.fromHandle}`).toLowerCase();
		api.igSendOTP(user.fromHandle)
		.then( () => {
			userStatus = 'PENDING';
			tick().then( () => document.getElementById('OTP').focus() );
		})
		.catch( err => {
			if( err == 403 )		showError(errors.ig_private_user);
			else if( err == 404 )	showError(errors.ig_nonexistent_user);
			else if( err == 409 )	showError(errors.otp_too_many_attempts);
			else if( err == 429 ||
					 err == 500 )	showError(errors.internal_error_2);
			else if( err )			showError(errors.no_network);
		})
		.finally( () => {
			input.classList.remove('disabled');
			action.classList.remove('disabled');
		});
	}

	/* (see storePrePaymentState()) */
	function restorePrePaymentState() {
		let prePaymentState = window.localStorage.getItem('prePaymentState');
		if( !prePaymentState )
			return false;

		prePaymentState = JSON.parse(prePaymentState);
		menu  = prePaymentState.menu;
		order = prePaymentState.order;
		boxes = prePaymentState.boxes;
		clearPrePaymentState();
		return true;
	}

	/* restore saved sender & recipient info, if any and if saved info belongs
	   to the current user. if there is saved info but it belongs to someone
	   else, purge it. if an address is restored, fetch and display its
	   associated delivery charge */
	function restoreUserInfo() {
		let pastHandle = window.localStorage.getItem('fromHandle');
		if( pastHandle != order.recipient.fromHandle )
			return window.localStorage.clear();

		['fromName','fromTel','toName','toTel','remarks'].forEach( field => {
			let value = window.localStorage.getItem(field);
			if( value )
				order.recipient[field] = value;
		});

		let toAddr = window.localStorage.getItem('toAddr');
		if( toAddr ) {
			order.recipient.toAddr = toAddr;
			fetchAndSetDeliveryCharge();
		}
	}

	/* set slot, and clear current order selection, if any */
	function setSlot(slot) {
		if( order.slot == slot )
			return;

		order.slot = slot;
		order.recipient.pickup = isDeliveryUnavailable();
		order.items = {};
		order.subtotals = [];
		order.total = 0;
		order.numPreOrderItems = 0;
		boxes = { num:1, curr:0 };
	}

	/* populate and reveal error banner with given error */
	function showError(err) {
		error = err;
	}

	/* svelte action to distinguish between single- and double-clicks (by
	   default, double-clicking on a node fires a click event followed by
	   a dblclick event)

	   REF: https://svelte.dev/tutorial/adding-parameters-to-actions
	   REF: https://github.com/sveltejs/svelte/issues/7340 */
	function sgldblclick(node) {
		const dblclickDelay = 250; //ms

		function handleClick() {
			node.__sgldblclick = node.__sgldblclick || {
				waiting: false,
				timer: null,
			};
			if( node.__sgldblclick.waiting ) {
				clearTimeout(node.__sgldblclick.timer);
				node.__sgldblclick.waiting = false;
				node.dispatchEvent( new CustomEvent('dblclick') );
			} else {
				node.__sgldblclick.waiting = true;
				node.__sgldblclick.timer = setTimeout(
					() => {
						node.__sgldblclick.waiting = false;
						node.dispatchEvent( new CustomEvent('sglclick') );
					},
					dblclickDelay
				);
			}
		}

		node.addEventListener('click', handleClick);

		return {
			destroy() {
				node.removeEventListener('click', handleClick);
			}
		};
	}

	/* svelte action to drag something down */
	function dragdown(node, {fromTopOnly, onDragEnd}) {
		let offsetY;
		let startY;

		function handlePress(ev) {
			offsetY = undefined;
			startY = undefined;

			if( !fromTopOnly || node.scrollTop == 0 )
				startY = ev.touches ? ev.touches[0].clientY : ev.clientY;
		}

		function handleMove(ev) {
			if( startY != undefined ) {
				offsetY = (ev.touches ? ev.touches[0].clientY : ev.clientY) - startY;
				if( offsetY > 0 )
					node.style.transform = `translate(0, ${offsetY}px)`;
			}
		}

		function handleRelease() {
			if( offsetY != undefined && offsetY > 0 )
				onDragEnd();
		}

		node.addEventListener('mousedown', handlePress);
		node.addEventListener('touchstart', handlePress);
		node.addEventListener('mousemove', handleMove);
		node.addEventListener('touchmove', handleMove);
		node.addEventListener('mouseup', handleRelease);
		node.addEventListener('touchend', handleRelease);

		return {
			destroy() {
				node.removeEventListener('mousedown', handlePress);
				node.removeEventListener('touchstart', handlePress);
				node.removeEventListener('mousemove', handleMove);
				node.removeEventListener('touchmove', handleMove);
				node.removeEventListener('mouseup', handleRelease);
				node.removeEventListener('touchend', handleRelease);
			}
		};
	}

	/// COPIED FROM /frontend/src/utils.js
	/* sort the given list of flavor names alphabetically, but with vegan flavors
  	   at the very end */
	function sortVegansLast(names) {
		return names.sort().sort( firstBy( name => name.startsWith('V ') ? 1 : 0 ) );
	}

	/// COPIED FROM /frontend/src/utils.js
	/* round possibly numerically unstable numbers to a maximum of 2 decimals
	   e.g.,
			8.2 * 3 = 24.599999999999998
			stabilizeNum(8.2 * 3) = 24.6 */
	function stabilizeNum(num) {
		return Math.round((num+Number.EPSILON)*100)/100;
	}

	/* store entire frontend state for restoration upon returning to this page
	   after redirection to an external payment page */
	function storePrePaymentState() {
		window.localStorage.setItem(
			'prePaymentState',
			JSON.stringify({menu,order,boxes}));
	}

	function submitOrder() {
		logInteraction('checked-out', {
			qtyOk: isOrderQtySufficient(),
			rcvOk: isRecipientValid(),
		});
		if( !isOrderQtySufficient() ) 	return showError(errors.incomplete_order);
		else if( !isRecipientValid() )	return showError(errors.incomplete_recipient);

		order.status = 'PROCESSING';
		window.mySwipe.disable();

		['fromHandle','fromName','fromTel','toName','toTel','toAddr','remarks'].forEach( field =>
			window.localStorage.setItem(field, order.recipient[field])
		);

		api.createOrder(order)
		.then( newId => {
			order.id = newId;
			if( stabilizeNum(orderAmount()) < config.minimumChargeableOrder ) {
				logInteraction('received-payment-complete (free)');
				order.status = 'CONFIRMED';
			} else {
				logInteraction('received-payment-form');
				order.status = 'PAYMENT';
				openOmisePaymentForm();
			}
		})
		.catch( err => {
			logInteraction('received-order-failed', {err});
			if( err == 400 )		showError(errors.invalid_params);
			else if( err == 404 )	showError(errors.menu_changed);
			else if( err == 410 )	showError(errors.lalamove_quote_expired);
			else if( err == 423 )	showError(errors.too_far);
			else if( err == 429 ) 	showError(errors.too_many_bookings);
			else if( err == 500 )	showError(errors.internal_error);
			else if( err == 503 ) 	showError(errors.no_lalamove_internal);
			else					showError(errors.no_network);
			order.status = 'DRAFT';
			window.mySwipe.enable();
		});
	}

	/* validate the entered OTP. on success, permanently log user in */
	function validateOTP() {
		let input = document.getElementById('OTP');
		input.classList.add('disabled');

		api.checkOTP(user.fromHandle,input.value)
		.then( authToken => login(user.fromHandle,authToken) )
		.catch( err => {
			if( err == 401 ) 		showError(errors.otp_incorrect);
			else if( err == 404 )	showError(errors.otp_expired);
			else if( err == 409 )	showError(errors.otp_too_many_attempts);
			else if( err == 500 )	showError(errors.internal_error_2);
			else 					showError(errors.no_network);
		})
		.finally( () => input.classList.remove('disabled') );
	}


	onMount( () => {
		if( userStatus == 'NEW' ) {
			window.localStorage.clear();
			document.getElementById('fromHandle').focus();
			return;
		}

		api.state.init(user.fromHandle,user.authToken);

		let urlParams = new URLSearchParams(window.location.search);
		let validate3dsPayment = urlParams.get('validate3dsPayment');
		if( !validate3dsPayment ) {
			logInteraction('page-loading');
			clearPrePaymentState();

			Promise.all([
				api.getMenu(),
				api.getCustomerPromos(user.fromHandle),
				loadGoogleMapsLibrary(),
				loadOmiseLibrary(),
			])
			.then( values => {
				menu = values[0];
				prepareMenu();

				/* order slot defaults to next open slot, if any */
				order.slot = Object.keys(menu.daySettings).find(hasOrderableItems) || order.slot;

				/* order pickup defaults to true if delivery is unavailable */
				order.recipient.pickup = isDeliveryUnavailable();

				order.recipient.fromHandle = user.fromHandle;
				restoreUserInfo();

				promos = values[1];
				promos.sort( firstBy('appliesTo').thenBy('id') );

				/* wait for loading to be complete before setting up the slider and
				   payment widgets. this gets us around the fact that swipejs doesn't
				   support a dynamic number of slides, without having to resort to
				   "error" slides that need to be swiped over. */
				loading = loadingGoogleMaps = false;
				tick().then( () => {
					initSwiper();

					if( !areAllSlotsClosed(menu) )
						initOmise();
				});
				logInteraction('page-loaded');
			})
			.catch( err => {
				if( err == 401 ) {
					window.localStorage.clear();
					showError(errors.invalid_credentials);
				} else
					showError(errors.no_network);
			});

		 } else if( restorePrePaymentState() ) {
		 	loadOmiseLibrary()
		 	.then( () => {
				loading = false;
				tick().then( () => {
					initSwiper(config.slides.REVIEW);
					window.mySwipe.disable();

					let {pay} = initOmise();
					pay({orderId:order.id, validate3dsPayment});
				});
			})
			.catch( err => {
				showError(errors.no_network);
			});

		/* ignore and scrap validate3dsPayment on manual page reloads (i.e., as
		   opposed to page loads resulting from 3DS redirects) */
		} else {
			logInteraction('page-manually-reloaded');
			reloadPage();
		}
	});

	document.onvisibilitychange = () => {
		if (document.visibilityState == 'hidden')
			logInteraction('page-closed');
	};
</script>


<style type="text/scss">
	@import "./style/theme.scss";

	:global(body) {
		background-color: $halo-logo-lemon-color-transparent;
		font-family: 'Quicksand', sans-serif;
		margin: auto;
		max-width: 550px;
		-webkit-tap-highlight-color: transparent;
	}

	.action {
		@extend .row-container;
		color: $halo-logo-tint-color;
		cursor: pointer;
		flex-basis: 10%;
		justify-content: center;
		min-height: 4em;
		text-align: center;
		text-decoration: underline;
	}

	.card {
		border-radius: 30px;
		padding: 30px;
		text-align: center;
		width: 100%;
	}

	.choosable {
		cursor: pointer;
		margin: 10px;
		text-align: center;

		.choice-body {
			@extend .row-container;
			border-radius: 100vh;
			border-style: dashed;
			border-width: 1px;
			justify-content: center;
			padding: 5px;
		}

		&.selected {
			.choice-body {
				color: $default-bg-color;
				background-color: $halo-logo-tint-color;
				border-color: transparent;

				.label {
					font-weight: 700;
				}
			}
		}
	}

	.control {
		cursor: pointer;
		text-align: center;
	}

	.header {
		padding: 6%;
		padding-bottom: 0;
		text-align: right;
		width: 100%;

		img {
			width: 80px;
		}
	}

	.instructions {
		.important {
			font-weight: 600;
		}
	}

	.section {
		background-color: $default-bg-color;
		height: 100%;
		position: relative;
		width: 100%;
	}

	.overlay {
		@extend .row-container;
		background-color: $default-bg-color-transparent;
		height: 100%;
		justify-content: center;
		position: absolute;
		width: 100%;
		top: 0;
	}

	.navigation {
		@extend .card;
	}

	.note {
		font-size: 0.8em;
		text-align: center;
	}

	.prompt {
		@extend .card;
		padding-top: 1.25em;
	}

	.spacer {
		flex-grow: 1;
	}

	.swipe {
		display: none;
		height: 100%;
		overflow: hidden;
		position: relative;
		visibility: hidden;
	}

	.swipe-wrap {
		height: 100%;
		overflow: hidden;
		position: relative;
	}

	.swipe-wrap > div {
		float: left;
		position: relative;
		overflow: auto;
		width: 100%;
	}

	.totals {
		@extend .row-container;
		flex-basis: 10%;
		justify-content: center;
		margin: auto;
		min-height: 5em;

		.total {
			@extend .column-container;
			min-width: 17em;

			.title {
				@extend .column-container;

				.note {
					font-style: italic;
				}
			}

			.price {
				flex-basis: 30%;
				font-weight: 600;
			}
		}
	}

	.vegan {
		color: $vegan-color;
	}

	#error {
		background-color: $error-color;
		color: $default-bg-color;
		font-weight: 600;
		padding: 10px;
		position: absolute;
		text-align: center;
		top: 0;
		width: 100%;
	}

	#register {
		@extend .row-container;
		@extend .section;
		font-size: 1.2em;
		justify-content: center;
		text-align: center;

		.logo {
			flex-basis: 30%;

			img {
				margin-top: 10%;
				width: 35%;
			}
		}

		.instructions {
			font-weight: 700;
		}

		input {
			background-color: transparent;
			border: none;
			color: $halo-logo-halo-color;
			font-size: 1.2em;
			font-weight: 700;
			outline: none;
			text-align: center;
			width: 100%;

			&::-webkit-input-placeholder {
				color: $blurred-color;
			}

		}

		#OTP {
			letter-spacing: 3px;
		}
	}

	#welcome {
		@extend .row-container;
		@extend .section;
		background-color: $halo-logo-tint-color;
		color: $default-bg-color;
		justify-content: center;

		.logo {
			flex-basis: 40%;

			img {
				margin-top: 24%;
				width: 47%;
			}
		}

		#hello {
			flex-basis: 25%;
			font-family: 'Spartan', sans-serif;
			font-size: 1.65em;
			font-weight: 500;
			padding-top: 35%;
			text-align: right;
			text-transform: uppercase;

			.important {
				font-weight: 800;
			}
		}
	}

	#dates {
		@extend .row-container;
		@extend .section;

		.choices {
			@extend .column-container;
			align-items: start;
			flex-wrap: wrap;
			justify-content: center;
			margin-bottom: 10px;

			.choice {
				@extend .column-container;
				@extend .choosable;
				flex-basis: 26%;
				justify-content: center;

				&:first-child {
					flex-basis: 100%;
				}

				.choice-body {
					height: 6em;
					width: 6em;

					.day-number {
						color: $halo-logo-halo-color;
					}

					.day-name {
						font-size: 1.3em;
						font-weight: 400;
					}

					.day-detail {
						color: $highlight-color;
						font-size: 0.85em;
					}
				}

				&.disabled {
					.day-number {
						color: $blurred-color;
					}
				}

				&.selected {
					.day-number {
						color: $default-bg-color;
					}

					.day-name {
						font-size: 1.5em;
					}
				}
			}
		}
	}

	#menu {
		@extend .row-container;
		@extend .section;

		.content-wrapper {
			@extend .row-container;
			justify-content: flex-start;
			/* overflow:auto and a wrapper div are needed for expanded-item to
			   always come from the bottom of the screen

			   REF: https://www.bennadel.com/blog/3409-using-position-absolute-inside-a-scrolling-overflow-container.htm */
			overflow: auto;

			#boxes {
				@extend .column-container;
				flex-basis: 8%;
				flex-shrink: 0;
				width: 100%;

				.action {
					flex-grow: 1;
				}

				.choices {
					@extend .column-container;
					flex-basis: 84%;
					flex-wrap: wrap;
					justify-content: space-around;
					padding-left: 12%;

					.box {
						@extend .choosable;

						.choice-body {
							width: 5em;
						}
					}
				}

				.control {
					flex-basis: 8%;
				}
			}

			#photo-items {
				align-items: center;
				display: grid;
				grid-template-columns: repeat(3, 31%);
				grid-auto-flow: dense;
				justify-content: center;
				margin-top: 15px;

				.item {
					font-size: 0.9em;
					margin-bottom: 1.5em;
					padding-left: 3px;
					padding-right: 3px;
					text-align: center;

					.info {
						img {
							width: 70%;
						}

						.name {
							font-weight: 900;
						}

						.price {
							font-size: 0.95em;
							padding-left: 3px;
						}
					}

					.controls {
						@extend .column-container;
						height: 1.15em;
						justify-content: center;

						.control {
							padding-left: 15px;
							padding-right: 15px;
						}

						.qty {
							color: $halo-logo-tint-color;
							font-size: 1.15em;
							font-weight: 900;
						}
					}

					&.soldout {
						.info {
							color: $blurred-color;
						}

						.info::after {
							color: $highlight-color;
							font-size: 0.8em;
							font-weight: 600;
							height: 1.15em;
							content: "SOLD OUT";
						}

						.controls {
							display: none;
						}
					}

					&.showcase {
						grid-column-end: span 2;
						grid-row-end: span 2;

						&:nth-child(even) {
							grid-column-start: 2;
						}

						.info {
							img {
								width: 85%;
							}
						}
					}
				}
			}

			#expanded-item {
				@extend .overlay;
				background-color: $default-fg-color-transparent;

				.details {
					@extend .row-container;
					align-items: center;
					background-color: $default-bg-color;
					border-top-left-radius: 24px;
					border-top-right-radius: 24px;
					height: 50%;
					justify-content: flex-start;
					overflow: auto;
					padding: 24px;
					position: absolute;
					top: 50%;
					width: 100%;

					.swipe-down-indicator {
						background-color: $secondary-color;
						border-radius: 3px;
						height: 6px;
						left: calc(50% - 50px/2);
						position: absolute;
						top: 12px;
						width: 50px;
					}

					img {
						max-width: 205px;
						padding: 8px;
						width: 60%;
					}

					.name {
						font-size: 1.1em;
						font-weight: 900;
					}

					.price {
						padding-left: 6px;
					}

					.description {
						font-size: 0.95em;
						padding-bottom: 3em;
						padding-top: 8px;
						text-align: center;

						.sub-name {
							font-weight: 600;
							padding-top: 0.5em;
						}

						.sub-description {
							padding-bottom: 0.5em;
						}
					}

					.controls {
						@extend .column-container;
						background-color: $default-bg-color-more-transparent;
						bottom: 0;
						font-size: 2em;
						justify-content: center;
						padding: 12px;
						position: fixed;
						width: 100%;

						.control {
							padding-left: 25px;
							padding-right: 25px;
						}

						.qty {
							color: $halo-logo-tint-color;
							font-weight: 900;
						}
					}
				}
			}
		}

		#items {
			@extend .row-container;

			.item {
				@extend .column-container;
				min-height: 2.5em;
				padding-bottom: 1em;

				.qty {
					color: $halo-logo-tint-color;
					flex-basis: 12%;
					font-size: 1.85em;
					text-align: center;
				}

				.info {
					@extend .row-container;
					flex-basis: 72%;

					.name-price-new {
						@extend .column-container;
						justify-content: start;

						.name {
							font-weight: 600;
							padding-right: 10px;
						}

						.price {
							color: $halo-logo-halo-color;
							font-weight: 600;
							padding-right: 10px;
						}

						.new {
							color: $highlight-color;
							font-style: italic;
						    font-weight: 600;
						}
					}

					.desc {
						font-size: 0.85em;
					}
				}

				.control {
					flex-basis: 8%;
				}

				&.soldout {
					.info {
						opacity: 0.4;
						pointer-events: none;
					}

					.control {
						color: $highlight-color;
						flex-basis: 16%;
						font-size: 0.8em;
					}
				}
			}
		}
	}

	#recipient {
		@extend .row-container;
		@extend .section;
		justify-content: flex-start;

		.choices-2 {
			@extend .column-container;
			justify-content: center;
			margin-bottom: 10px;

			.choice {
				@extend .choosable;
				flex-basis: 44%;
				max-width: 11em;

				&.selected {
					.label {
						font-size: 1.2em;
					}
				}
			}
		}

		#pickupAndDelivery {
			@extend .choices-2;
			min-height: 6em;

			.choice-body {
				height: 5em;

				.note {
					&.unavailable {
						color: $highlight-color;
					}
				}
			}
		}

		#forSelfOrFriendChoices {
			@extend .choices-2;
			min-height: 5em;

			.choice-body {
				height: 4em;
			}
		}

		#forSelfOrFriendFields {
			@extend .column-container;
			justify-content: space-evenly;

			.name-number {
				@extend .row-container;
				flex-basis: 45%;

				&[_toSelf="true"] {
					flex-basis: 75%;
				}
			}
		}
	}

	#review {
		@extend .row-container;
		@extend .section;

		.prompt {
			color: $halo-logo-tint-color;
			font-family: 'Spartan', sans-serif;
			font-size: 1.35em;
			font-weight: 800;
			line-height: 1.25em;
			margin-top: -2.5em;
			padding-top: 0;
			text-align: left;
			text-transform: uppercase;
		}

		.handle {
			color: $halo-logo-halo-color;
			font-weight: 800;
		}

		.fields {
			@extend .column-container;
			align-items: start;
			flex-wrap: wrap;

			.field {
				padding-bottom: 20px;
				padding-left: 30px;
				padding-right: 30px;
				min-width: 50%;

				&:not(.box) {
					width: 100%;
				}

				.title {
					border-bottom-width: 1px;
					border-bottom-style: solid;
					border-bottom-color: $halo-logo-tint-color;
					color: $halo-logo-tint-color;
					font-weight: 400;
					margin-bottom: 4px;
					padding-bottom: 4px;
				}

				.value {
					line-height: 1.5em;
					padding-left: 4px;

					.important {
						font-weight: 800;
					}
				}
			}
		}

		.promos {
			@extend .row-container;

			.choice {
				@extend .column-container;
				@extend .choosable;
				justify-content: flex-start;
				margin: 4px;

				.choice-body {
					flex-basis: 30%;
					flex-shrink: 0;
					margin-right: 10px;
				}

				.description {
					font-size: 0.85em;
					font-style: italic;
					text-align: left;
				}

				&.selected {
					.description {
						font-weight: 800;
					}
				}
			}
		}

		#checkout {
			@extend .card;
			padding-top: 0px;

			.button {
				background-color: $halo-logo-tint-color;
				color: $default-bg-color;
				cursor: pointer;
				font-size: 1.125em;
				font-weight: 600;
				margin: 15px;
				padding: 15px;
				text-align: center;

				&.processing {
					background-color: $blurred-color;
					pointer-events: none;
				}

				.wrong-price {
					text-decoration: line-through;
				}
			}

			#terms {
				font-size: 0.8em;
				margin-left: 5px;
				margin-right: 5px;
				text-align: left;

				.summary {
					color: $secondary-color;

					.link {
						cursor: pointer;
						text-decoration: underline;
					}
				}

				.full {
					margin-left: 5px;
					margin-right: 5px;

					.title {
						font-weight: 700;
						margin-top: 1em;
					}
				}
			}
		}

		#payment {
			@extend .overlay;
			@extend .row-container;
			justify-content: flex-start;

			.instructions {
				margin-top: 5%;
				padding: 30px;
				text-align: center;
			}

			#omiseLoading {
				background-color: $default-bg-color;
				border-color: $omise-color;
				border-radius: 12px;
				border-style: solid;
				border-width: 0px;
				box-shadow: 0px 0px 6px 2px $omise-color;
				height: 595px;
				left: calc(50% - 320px/2);
				position: fixed;
				top: min(18%, 150px);
				width: 320px;

				div:first-child {
					padding-left: calc(320px/2 - 60px/2);
					padding-top: calc(595px/2 - 60px/2);
				}
			}

			#omiseSpacer {
				min-height: 595px;
			}
		}

		#confirmation {
			@extend .card;
		}
	}
</style>


{#if userStatus != 'OK'}
	<div id="register"
		on:click={clearError}
		on:touchstart={clearError}
		on:mousedown={clearError}
		on:keyup={clearError}>
		<div class="logo">
			<img src="/images/logo-blacktext-nobg-256px.png" alt="logo"/>
		</div>
		{#if userStatus == 'NEW'}
			<div class="card">
				Hallooo! Looks like this is your first time here. Please enter your Instagram handle so we can get you set up.
			</div>
			<div class="card">
				<div class="instructions">
					Enter your Instagram handle
				</div>
				<input id="fromHandle"
					type="text"
					autocomplete="nope"
					placeholder="e.g., @ilovedoughnuts "
					spellcheck=false
					bind:value={user.fromHandle}
					on:keyup={ev => {
						user.fromHandle = user.fromHandle.toLowerCase();
						if( ev.keyCode == 13 && inputValidatorFns.fromHandle(user.fromHandle) )
							registerWithoutOTP();
					}}/>
			</div>
			<div class="spacer"></div>
			{#if inputValidatorFns.fromHandle(user.fromHandle)}
				<div id="requestOTP"
					class="action"
					on:click={registerWithoutOTP}>
					Next
				</div>
			{/if}
		{:else if userStatus == 'PENDING'}
			<div class="card">
				We just DMed you. You're one little OTP away from doughnut Heaven.
			</div>
			<div class="card">
				<div class="instructions">
					Enter your OTP
				</div>
				<input id="OTP"
					type="number"
					autocomplete="nope"
					placeholder="000000"
					maxlength="6"
					on:keyup={ev => {
						if( ev.target.value.length > ev.target.maxLength )
							ev.target.value = ev.target.value.slice(0,ev.target.maxLength);
						else if( inputValidatorFns.OTP(ev.target.value) )
							validateOTP();
					}}/>
			</div>
		{/if}
		<div class="spacer"></div>
	</div>

{:else if loading}
	<div id="welcome">	<!-- TODO TBC Factorize both "welcome" divs -->
		<div class="logo">
			<img src="/images/logo-whitetext-noloop-256px.gif" alt="logo"/>
		</div>
		<div class="card"></div>
		<div class="spacer"></div>
		<div class="navigation"></div>
	</div>
{/if}

<div id="slider" class="swipe"
	on:click={onBlur}
	on:touchstart={onBlur}
	on:mousedown={onBlur}>
	<div class="swipe-wrap">
		<div id="welcome">
			<div class="logo">
				<img src="/images/logo-whitetext-noloop-256px.gif" alt="logo"/>
			</div>
			<div id="hello" class="card">
				<span class="important">
					Your<br/>
					taste buds
				</span><br/>
				have<br/>
				reached<br/>
				<span class="important">
					the Gates<br/>
					of Heaven
				</span>
			</div>
			<div class="spacer"></div>
			<div class="navigation">
				Swipe &#x21E6; to get started
			</div>
		</div>

		{#if !areAllSlotsClosed(menu)}
			<div id="dates">
				<div class="header">
					<img src="/images/logo-notext-nobg-96px.png" alt="logo"/>
				</div>
				<div class="prompt">
					When would you like to stuff your face with doughnuts?
				</div>
				<div class="choices">
					{#each Object.keys(menu.daySettings) as day}
						<div class="choice"
							class:selected={order.slot == menu.daySettings[day].df.YYYYMMDD}
							class:disabled={!hasOrderableItems(day)}
							on:click={() => setSlot(menu.daySettings[day].df.YYYYMMDD)}>
							<div class="choice-body">
								<div class="day-number">
									{#if day != today}
										{menu.daySettings[day].df.Do}
									{/if}
								</div>
								<div class="day-name label">
									{day == today ? 'Now!' : menu.daySettings[day].df.ddd}
								</div>
								<div class="day-detail">
									{#if !hasOrderableItems(day)}
										{#if isOpeningSoon(day)}
											OPEN @ {config.openingHour}
										{:else}
											SOLD OUT
										{/if}
									{:else if menu.daySettings[day].vegan}
										&#x1F331;
									{/if}
								</div>
							</div>
						</div>
					{/each}
				</div>
				<!-- <div class="note vegan">
					<br/>
					&#x1F331; : vegan doughnuts available
				</div> -->
				<div class="spacer"></div>
				<div class="spacer"></div>
				<div class="navigation">
					Swipe &#x21E6; for the menu
				</div>
			</div>

			<div id="menu"
				class:scroll-lock={showExpandedItem.mi}>
				<div class="content-wrapper">
					<div class="header">
						<img src="/images/logo-notext-nobg-96px.png" alt="logo"/>
					</div>
					<div class="prompt">
						Which ones would you like?<br/>
						Pro tip: they're all yumz ;)
					</div>
					{#if config.usePhotoMenu}
						<div id="photo-items">
							{#each (menu.daySettings[order.slot]?.fullSortedMenu || []) as mi}
								<div class="item"
									class:soldout={!isItemAddableToOrder(mi, order.items) && !getItemQty(mi, order.items, boxes.curr)}
									class:showcase={mi.__isMultiItem}>
									<div class="info"
										use:sgldblclick
										on:sglclick|self={() => showExpandedItem.mi = mi}
										on:dblclick|self={ev => {
											if( ev instanceof CustomEvent ) { // ignore non-synthetic dblclick events
												if( isItemAddableToOrder(mi, order.items) )
													incrementItemQty(mi,+1);
											}
										}}>
										<img alt={mi.name}
											src={mi.__imageSrc}
											on:error={(ev) => mi.__imageSrc = mi.__placeholderImageSrc(missingMenuItemImageCount++)}/>
										<br/>
										<span class="name"
											class:vegan={mi.name.startsWith('V ')}>
											{mi.__normalizedName}
										</span>
										{#if measureTextWidth(mi.__normalizedName) < 72}
											<br/>
										{/if}
										<span class="price">{mi.price}</span>
										<br/>
									</div>
									<div class="controls"
										class:invisible={!getItemQty(mi, order.items, boxes.curr)}>
										<div class="control"
											class:disabled={!getItemQty(mi, order.items, boxes.curr)}
											on:click={() => incrementItemQty(mi,-1)}>
											-
										</div>
										<div class="qty">{getItemQty(mi, order.items, boxes.curr) || ' '}</div>
										<div class="control"
											class:disabled={!isItemAddableToOrder(mi, order.items)}
											on:click={() => incrementItemQty(mi,+1)}>
											+
										</div>
									</div>
								</div>
							{/each}
						</div>
					{:else}
						<div id="items">
							{#each (menu.daySettings[order.slot]?.fullSortedMenu || []) as mi}
								<div class="item"
									class:soldout={!isItemAddableToOrder(mi, order.items) && !getItemQty(mi, order.items, boxes.curr)}>
									<div class="qty">
										{getItemQty(mi, order.items, boxes.curr) || ' '}
									</div>
									<div class="info"
										on:click={() => {
											if( isItemAddableToOrder(mi, order.items) )
												incrementItemQty(mi,+1);
										}}>
										<div class="name-price-new">
											<div class="name"
												class:vegan={mi.name.startsWith('V ')}>
												{mi.__normalizedName}
											</div>
											<div class="price">{mi.price}</div>
											{#if mi.new}
												<div class="new">NEW</div>
											{/if}
										</div>
										<div class="desc"
											class:vegan={mi.name.startsWith('V ')}>
											{#if mi.items}
												{#if mi.__isMultiItem}
													{@html Object.entries(mi.items).map( ([_name,_info]) => `${_info.qty} x ${_name}` ).join('<br/>')}
												{:else}
													{Object.values(mi.items)[0].description}
												{/if}
											{:else}
												{mi.description}
											{/if}
										</div>
									</div>
									{#if !isItemAddableToOrder(mi, order.items) && !getItemQty(mi, order.items, boxes.curr)}
										<div class="control">
											SOLD<br/>
											OUT
										</div>
									{:else}
										<div class="control"
											class:invisible={!isItemAddableToOrder(mi, order.items)}
											on:click={() => incrementItemQty(mi,+1)}>
											+
										</div>
										<div class="control"
											class:invisible={!getItemQty(mi, order.items, boxes.curr)}
											on:click={() => incrementItemQty(mi,-1)}>
											-
										</div>
									{/if}
								</div>
							{/each}
						</div>
					{/if}
					<div id="boxes">
						{#if boxes.num == 1}
							<div class="action"
								on:click={() => quickOrder('add-box')}>
								Add another box
							</div>
						{:else}
							<div class="choices">
								{#each new Array(boxes.num) as _,i}
										<div class="box"
											class:selected={boxes.curr == i}
											on:click={() => boxes.curr = i}>
											<div class="choice-body">
												<div class="label">
													BOX #{i+1}
												</div>
											</div>
										</div>
								{/each}
							</div>
							<div class="control"
								class:invisible={boxes.num == config.maximumBoxesPerOrder}
								on:click={() => quickOrder('add-box')}>
								+
							</div>
							<div class="control"
								on:click={removeCurrentBox}>
								-
							</div>
						{/if}
					</div>
					<div class="spacer"></div>
					<div class="totals">
						{#if boxes.num > 1}
							<div class="total">
								<div class="title">
									Sub-Total&nbsp;<span class="note">(BOX #{boxes.curr+1})</span>
								</div>
								<div class="price">
									MYR {stabilizeNum(order.subtotals[boxes.curr] || 0)}
								</div>
							</div>
						{/if}
						<div class="total">
							<div class="title">
								Total&nbsp;<span class="note">(excluding delivery)</span>
							</div>
							<div class="price">
								MYR {stabilizeNum(order.total)}
							</div>
						</div>
					</div>
					<div class="navigation">
						Swipe &#x21E6; for delivery details
					</div>
					{#if config.usePhotoMenu && showExpandedItem.mi}{#each [showExpandedItem.mi] as mi}
						<div id="expanded-item"
							in:fade="{{ duration: 100 }}"
							out:fade="{{ duration: 75 }}"
							on:introend="{() => showExpandedItem.showDetails = true}"
							on:click={() => showExpandedItem.showDetails = false}>
							{#if showExpandedItem.showDetails}
								<div class="details"
									in:fly="{{ y: screen.height*.5, duration: 200 }}"
									out:fly="{{ y: screen.height*.5, duration: 150 }}"
									on:outroend="{() => showExpandedItem.mi = null}"
									on:click|stopPropagation={() => {}}
									use:dragdown={{
										fromTopOnly: true,
										onDragEnd: () => {
											showExpandedItem.showDetails = false;
										},
									}}>
									<div class="swipe-down-indicator"></div>
									<img alt={mi.name}
										src={mi.__imageSrc}/>
									<div>
										<span class="name">
											{mi.__normalizedName}
										</span>
										<span class="price">{mi.price}</span>
									</div>
									<div class="description">
										{#if mi.items}
											{#if mi.__isMultiItem}
												{#each Object.keys(mi.items) as name}
													<div class="sub-name">
														{mi.items[name].qty} x {name}
													</div>
													<div class="sub-description">
														{mi.items[name].description}
													</div>
												{/each}
											{:else}
												{Object.values(mi.items)[0].description}
											{/if}
										{:else}
											{mi.description}
										{/if}
									</div>
									<div class="controls">
										<div class="control"
											class:disabled={!getItemQty(mi, order.items, boxes.curr)}
											on:click={() => incrementItemQty(mi,-1)}>
											-
										</div>
										<div class="qty">{getItemQty(mi, order.items, boxes.curr)}</div>
										<div class="control"
											class:disabled={!isItemAddableToOrder(mi, order.items)}
											on:click={() => incrementItemQty(mi,+1)}>
											+
										</div>
									</div>
								</div>
							{/if}
						</div>
					{/each}{/if}
				</div>
			</div>

			<div id="recipient"> <!-- TODO TBC Factorize both "recipient" divs -->
				<div class="header">
					<img src="/images/logo-notext-nobg-96px.png" alt="logo"/>
				</div>
				<div class="prompt">
					Who are these doughnuts for and how are they getting 'em?
				</div>
				<div id="pickupAndDelivery">
					<div class="choice"
						class:disabled={isDeliveryUnavailable(order.slot)}
						class:selected={!order.recipient.pickup}
						on:click={() => order.recipient.pickup = false}>
						<div class="choice-body">
							<div class="label">
								Delivery
							</div>
							{#if isDeliveryUnavailable(order.slot)}
								<div class="note"
									class:unavailable={true}>
									Unavailable
									<br/>
									at the moment
								</div>
							{:else}
								<div class="note">
									{menu.timeSettings.deliveryWindow}
								</div>
							{/if}
						</div>
					</div>
					<div class="choice"
						class:selected={order.recipient.pickup}
						on:click={() => order.recipient.pickup = true}>
						<div class="choice-body">
							<div class="label">
								Self-pickup
							</div>
							<div class="note">
								{menu.timeSettings.pickupWindow}
								<br/>
								The Gasket Alley
							</div>
						</div>
					</div>
				</div>
				{#if !areAllSlotsClosed(menu)}
					<div id="forSelfOrFriendChoices">
						<div class="choice"
							class:selected={order.recipient.toSelf}
							on:click={() => order.recipient.toSelf = true}>
							<div class="choice-body">
								<div class="label">
									For MEEE!
								</div>
							</div>
						</div>
						<div class="choice"
							class:selected={!order.recipient.toSelf}
							on:click={() => order.recipient.toSelf = false}>
							<div class="choice-body">
								<div class="label">
									For a friend
								</div>
							</div>
						</div>
					</div>
					<div id="forSelfOrFriendFields">
						<div class="name-number"
							_toSelf={order.recipient.toSelf}>
							<TextInput
								label = {order.recipient.toSelf ? "Name" : "Your name"}
								validatorFn = {inputValidatorFns.fromName}
								bind:value = {order.recipient.fromName} />
							<TextInput
								label = {order.recipient.toSelf ? "Phone #" : "Your phone #"}
								type = "tel"
								placeholder = "+60XX ..."
								validatorFn = {inputValidatorFns.fromTel}
								bind:value = {order.recipient.fromTel} />
						</div>
						<div class="name-number"
							class:hidden={order.recipient.toSelf}>
							<TextInput
								label = "Friend's name"
								validatorFn = {inputValidatorFns.toName}
								bind:value = {order.recipient.toName} />
							<TextInput
								label = "Friend's phone #"
								type = "tel"
								placeholder = "+60XX ..."
								validatorFn = {inputValidatorFns.toTel}
								bind:value = {order.recipient.toTel} />
						</div>
					</div>
				{/if}
				<div class="row-container"
					class:hidden={order.recipient.pickup}>
					{#if loadingGoogleMaps}
						<TextInput
							id = "toAddrPlaceholder"
							label = {order.recipient.toSelf ? "Address" : "Friend's address"}
							disabled = true />
					{:else}
						<AddressInput
							id = "toAddr"
							label = {order.recipient.toSelf ? "Address" : "Friend's address"}
							kitchenAddress = {config.kitchenAddress}
							onAddressChangeFn = {onAddressChange}
							value = {_.cloneDeep(order.recipient.toAddr)} />
					{/if}
					{#if !areAllSlotsClosed(menu)}
						<TextInput
							id = "remarks"
							label = "Address details"
							placeholder = "Unit #, block, ..."
							optional = true
							validatorFn = {inputValidatorFns.remarks}
							bind:value = {order.recipient.remarks} />
					{/if}
				</div>
				{#if !areAllSlotsClosed(menu)}
					<TextInput
						label = "Personalized message"
						limits = {config.personalizedMessageLimits}
						optional = true
						help = "Maximum {config.personalizedMessageLimits.maxLines} lines and {config.personalizedMessageLimits.maxChars} characters"
						validatorFn = {inputValidatorFns.notes}
						bind:value = {order.notes} />
				{/if}
				<div class="totals"
					class:invisible={order.recipient.pickup || !order.recipient.toAddr}>
					<div class="total">
						<div class="title">
							Delivery fee
						</div>
						<div class="price">
							{order.shipping ? `MYR ${order.shipping}` : '(calculating...)'}
						</div>
					</div>
					{#if order.shipping}
						<div class="total">
							<div class="title">
								Total&nbsp;<span class="note">(including delivery)</span>
							</div>
							<div class="price">
								MYR {stabilizeNum(order.total+order.shipping)}
							</div>
						</div>
					{/if}
				</div>
				<div class="spacer"></div>
				<div class="navigation"
					class:hidden={areAllSlotsClosed(menu)}>
					Swipe &#x21E6; for payment
				</div>
			</div>

			<div id="review">
				<div class="header">
					<img src="/images/logo-notext-nobg-96px.png" alt="logo"/>
				</div>
				<div class="prompt">
					Order<br/>
					summary
				</div>
				<div class="fields">
					<div class="field">
						<div class="title">Date & time :</div>
						<div class="value">
							{dayjs(order.slot).format('dddd MMMM Do')}
							<br/>
							{#if order.recipient.pickup}
								Pickup: {menu.timeSettings.pickupWindow}
							{:else}
								Delivery: {menu.timeSettings.deliveryWindow}
							{/if}
						</div>
					</div>
					{#if order.recipient.toSelf}
						<div class="field">
							<div class="title">Contact{order.recipient.pickup ? '' : ' & delivery'} info :</div>
							<div class="value">
								<span class="handle">{order.recipient.fromHandle}</span><br/>
								<span class="important">{order.recipient.fromName}</span><br/>
								{order.recipient.fromTel}
								{#if !order.recipient.pickup}
									<br/>
									{order.recipient.toAddr}
									{#if order.recipient.remarks}
										<br/>
										({order.recipient.remarks})
									{/if}
								{/if}
							</div>
						</div>
					{:else}
						<div class="field">
							<div class="title">Your contact info :</div>
							<div class="value">
								<span class="handle">{order.recipient.fromHandle}</span><br/>
								<span class="important">{order.recipient.fromName}</span><br/>
								{order.recipient.fromTel}<br/>
							</div>
						</div>
						<div class="field">
							<div class="title">Recipient's contact{order.recipient.pickup ? '' : ' & delivery'} info :</div>
							<div class="value">
								<span class="important">{order.recipient.toName}</span><br/>
								{order.recipient.toTel}
								{#if !order.recipient.pickup}
									<br/>
									{order.recipient.toAddr}
									{#if order.recipient.remarks}
										<br/>
										({order.recipient.remarks})
									{/if}
								{/if}
							</div>
						</div>
					{/if}
					{#each new Array(boxes.num) as _,i}
						<div class="field box">
							<div class="title">{boxes.num > 1 ? `BOX #${i+1}` : `In the box`} :</div>
							<div class="value">
								{#each sortVegansLast(Object.keys(order.items)) as name}
									{#if order.items[name][i]}
										{order.items[name][i]} x {name}
										<br/>
									{/if}
								{/each}
							</div>
						</div>
					{/each}
					{#if order.notes}
						<div class="field">
							<div class="title">Message :</div>
							<div class="value"
								style="white-space: pre-wrap;">
								{order.notes}
							</div>
						</div>
					{/if}
					{#if promos.length}
						<div class="field">
							<div class="title">Your promotions :</div>
							<div class="promos">
								{#each promos as p}
									<div class="choice"
										class:selected={order.promoId == p.id}
										on:click={() => order.promoId = (order.promoId == p.id ? null : p.id)}>
										<div class="choice-body">
											{p.appliesTo}{p.maxAmount}
										</div>
										<div class="description">
											{promoDescription(p)}
										</div>
									</div>
								{/each}
							</div>
						</div>
					{/if}
				</div>
				<div class="spacer"></div>
				{#if order.status == 'DRAFT' || order.status == 'PROCESSING'}
					<div id="checkout">
						<div class="button"
							class:processing={order.status == 'PROCESSING'}
							on:click|stopPropagation={submitOrder}>
							Checkout - MYR
							{#if order.promoId}
								<span class="wrong-price">
									{stabilizeNum(order.total + (order.recipient.pickup ? 0 : order.shipping))}
								</span>
							{/if}
							{stabilizeNum(orderAmount(order))}
						</div>
						<div id="terms">
							<div class="summary"
								on:click={() => showTnCs = !showTnCs}>
								For those of you who enjoy a good read with your doughnuts, here are some fun
								<span class="link">terms and conditions</span> and our
								<span class="link">company details</span>
							</div>
							{#if showTnCs}
								<div class="full">
									<div class="title">Delivery Policy</div>
									- Deliveries are fulfilled by Lalamove<br/>
									- Your doughnuts should arrive in a sticker-sealed box/bag<br/>

									<div class="title">Refund Policy</div>
									- If we sent you the wrong doughnuts or if your doughnuts were mishandled during delivery, please get in touch with us via Instagram DM for refunds and/or replacements<br/>

									<div class="title">Privacy Policy</div>
									- We share your contact details with our delivery partner, as needed, but not with anyone else<br/>
									- We never store or share any of your payment information<br/>

									<div class="title">Company Details</div>
									Good Dough Sdn Bhd (1367917-W)<br/>
									Lot 15-3B, The Gasket Alley, Jalan 13/6, Seksyen 13, 46200, Petaling Jaya, Malaysia<br/>
									hello@halodoughnut.com<br/>
									+60362117267<br/>
								</div>
							{/if}
						</div>
					</div>
				{:else if order.status == 'CONFIRMED'}
					<div id="confirmation">
						Thank you for your order.<br/>
						An update will be sent to {order.recipient.fromHandle} when it's ready for {order.recipient.pickup ? 'pickup' : 'delivery'}.
						<div class="action"
							on:click={reloadPage}>
							Make another order
						</div>
					</div>
				{/if}
				<div id="payment"
					class:hidden={order.status != 'PAYMENT'}>
					<div class="instructions">
						These little halos have your name on them. Complete payment within
						<span class="important">{config.paymentGracePeriod} minutes</span>
						to make sure they don't roll away.
					</div>
					<!-- the omiseLoading and omiseIframe elements have absolute positioning
					     (so they can be overlaid easily) and as such don't properly extend
					     the size of their parent. omiseSpacer ensures that there is always
					     enough room (including some padding) for them regardless of device
					     screen size -->
					<div id="omiseSpacer"></div>
					<div id="omiseLoading">
						<div>
							<LoadingCircle color="#215cec" size="60" unit="px" duration="1s"></LoadingCircle>
						</div>
					</div>
				</div>
			</div>
		{:else}
			<div id="recipient">
				<div class="header">
					<img src="/images/logo-notext-nobg-96px.png" alt="logo"/>
				</div>
				<div class="spacer"></div>
				<div class="prompt">
					Halo! Looks like we're not taking online orders at the moment. Watch out for updates on our Instagram!
					<br/><br/>
					You can still check our delivery rates and options below though :)
					<br/><br/>
				</div>
				<div id="pickupAndDelivery">
					<div class="choice"
						class:selected={!order.recipient.pickup}
						on:click={() => order.recipient.pickup = false}>
						<div class="choice-body">
							<div class="label">
								Delivery
							</div>
							<div class="note">
								{menu.timeSettings.deliveryWindow}
							</div>
						</div>
					</div>
					<div class="choice"
						class:selected={order.recipient.pickup}
						on:click={() => order.recipient.pickup = true}>
						<div class="choice-body">
							<div class="label">
								Self-pickup
							</div>
							<div class="note">
								{menu.timeSettings.pickupWindow}
								<br/>
								The Gasket Alley
							</div>
						</div>
					</div>
				</div>
				<div class:invisible={order.recipient.pickup}>
					{#if loadingGoogleMaps}
						<TextInput
							id = "toAddrPlaceholder"
							label = "Address"
							disabled = true />
					{:else}
						<AddressInput
							id = "toAddr"
							label = "Address"
							kitchenAddress = {config.kitchenAddress}
							onAddressChangeFn = {onAddressChange}
							value = {_.cloneDeep(order.recipient.toAddr)} />
					{/if}
				</div>
				<div class="totals"
					class:invisible={order.recipient.pickup || !order.recipient.toAddr}>
					<div class="total">
						<div class="title">
							Delivery fee
						</div>
						<div class="price">
							{order.shipping ? `MYR ${order.shipping}` : '(calculating...)'}
						</div>
					</div>
				</div>
				<div class="spacer"></div>
				<div class="spacer"></div>
			</div>
		{/if}
	</div>
</div>

<div id="error"
	class:hidden={!error}>
	{error ? error.msg : ''}
</div>